<template>
  <div class="position-page">
    <div class="position-page__content container">
      <div class="position-page__header">
        <div class="position-page__header-section">
          <Tag class="position-page__scope" data-aos="fade-right">
            {{ position?.department }}
          </Tag>
          <p
            class="position-page__property"
            v-for="(property, i) in properties"
            :key="property.icon"
            data-aos="fade-right"
            :data-aos-delay="(i + 1) * 200"
          >
            <i class="fa-solid" :class="property.icon" />
            {{ property.value }}
          </p>
        </div>
        <div class="position-page__header-section">
          <Button href="/careers" data-aos="fade-left" data-aos-delay="600">
            <i class="fa-solid fa-angle-left" />
            Back to all jobs
          </Button>
        </div>
      </div>
      <h1 class="position-page__name" data-aos="fade-up" data-aos-delay="100">
        {{ position?.name }}
      </h1>
      <Article data-aos="fade-up" data-aos-delay="100">
        <div
          class="position-page__description"
          v-html="position?.description"
        />
      </Article>
    </div>
    <div class="position-page__footer">
      <ScreenHeader class="position-page__footer-header" data-aos="fade-up">
        <template #subtitle> Ready to Join? </template>
        <template #title> Apply Now! </template>
      </ScreenHeader>
      <!--      <Button size="lg">-->
      <!--        Apply-->
      <!--      </Button>-->
      <div class="container">
        <div class="position-page__application-form">
          <JobApplicationForm :job-id="jobId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  definePageMeta({
    settings: {
      cover: {
        title: "Job",
      },
    },
  });
  const route = useRoute();
  const jobId = Number(route.params.jobId);

  const { getJobById } = useWebsiteContent();
  const { data: position, suspense: positionSuspense } = getJobById(jobId);
  await positionSuspense();

  const properties = computed(() => [
    {
      icon: "fa-location-dot",
      value: position.value?.location,
    },
    {
      icon: "fa-clock",
      value: position.value?.employmentType,
    },
  ]);
</script>

<style lang="scss">
  .position-page {
    &__content {
      padding-top: 64px;
    }

    &__header {
      display: flex;
      align-items: center;
      gap: 24px;
      justify-content: space-between;

      margin-bottom: 32px;
    }

    &__header-section {
      display: flex;
      align-items: center;
      gap: 24px;

      @media (max-width: $sm) {
        align-items: center;
        flex-wrap: wrap;
        gap: 16px;
      }
    }

    &__go-back {
      color: #212529;
      font-family: var(--font-family-main);
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      @media (max-width: $sm) {
        display: none;
      }
    }

    &__scope {
    }

    &__property {
      display: flex;
      align-items: center;
      gap: 8px;

      color: #212529;
      font-family: var(--font-family-main);
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &__name {
      color: #212529;
      font-family: var(--font-family-main);
      font-size: 48px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;

      margin-bottom: 16px;
    }

    &__description {
      ul,
      ol {
        br {
          display: none;
        }
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        ~ br {
          display: none;
        }
      }
    }

    &__footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 32px;

      margin-top: 64px;

      padding: 64px 0;

      background-image: url("@/assets/images/job-application-bg.svg");
      background-size: cover;
      background-position: top center;
    }

    &__application-form {
      width: 100%;
      max-width: 560px;
      margin: 0 auto;
    }
  }
</style>
